import Floor from "@modules/navigator/Floor/Floor.js";
import Space from "@modules/navigator/Space/Space.js";
import Navigator from "@modules/navigator/Navigator.js";

const NavigatorRouter = {
    state: {},
    floors: [],

    init() {
        if (typeof (navigatorBaseUrl) === 'undefined') {
            return;
        }

        this.baseUrl = navigatorBaseUrl;
        this.floors = NAVIGATOR_DATA.floors;

        this.state = {
            building: NAVIGATOR_DATA.building,
            floor: null,
            space: null,
            direction: 0
        };

        this.bind();
    },

    bind() {
        window.addEventListener("load", (evt) => {
            this.parseUrl();
        })

        window.addEventListener("popstate", (evt) => {
            this.state = evt.state
            this.set(this.state);
        });
    },

    setFloor(nmb, direction) {
        if (this.debug) console.log('setFloor', nmb, direction)
        this.state.floor = Number.isInteger(nmb) ? this.floors[nmb] : null;
        this.state.direction = direction;
        this.route();
    },

    setSpace(nmb, direction) {
        this.state.space = nmb ? NAVIGATOR_DATA.flats[nmb] : null;
        this.state.direction = direction;

        if (nmb && Space.isSold(this.state.space)) {
            return;
        }

        this.route()
    },

    route() {
        let url = WEB_ROOT + "/" + navigatorBaseUrl;
        if (this.debug) console.log('Navigator.route', this.state);

        if (this.state.floor) url += '/' + this.state.floor.number + '-podlazie';
        if (this.state.space) url += '/' + this.state.space.url;

        if (!Navigator.isPriceListPage()) {
            history.pushState(this.state, null, url);
        }
        this.set(this.state);
    },

    set(state) {
        if (!state) return;

        if (Navigator.isPriceListPage()) {
            if (state.space) {
                Space.show(state.space);
            } else {
                Space.hide();
            }

            Navigator.setHeight();
            return;
        }

        if (state.floor) {
            Navigator.view = 'floor';
            Floor.show(state.floor, state.direction);

            if (state.space) {
                Navigator.view = 'space';
                Space.show(state.space);
            } else {
                Navigator.view = 'floor';
                Space.hide();
            }

        } else {
            Floor.hide();
            Space.hide();
            Navigator.view = 'building';
        }

        Navigator.setHeight();
    },

    parseUrl() {
        const currentUrl = new URL(window.location.href);

        // Remove WEB_ROOT + navigatorBaseUrl from the pathname
        const basePath = `/${navigatorBaseUrl}/`;
        let relativePath = currentUrl.pathname.replace(`${WEB_ROOT}${basePath}`, '');
        const pathSegments = relativePath.split('/').filter(Boolean);

        if (this.debug) {
            console.log('--- Navigator.parseUrl ---');
            console.log('Current URL:', currentUrl.href);
            console.log('Relative Path:', relativePath);
            console.log('Path Segments:', pathSegments);
        }

        if (!pathSegments.length) return;

        // e.g. "3-podlazie" → "3"
        const floorKey = pathSegments[1]?.split('-')[0] || null;

        // e.g. "nebytovy-priestor-3A" → "3A"
        const spaceSegment = pathSegments[2];
        const spaceKey = spaceSegment?.split('-').pop() || null;

        const floor = this.floors?.[floorKey] || null;
        const space = floor?.flats?.[spaceKey] || null;

        this.state.floor = floor;
        this.state.space = space;

        this.set(this.state);
    }
}

export default NavigatorRouter;